module.exports = __webpack_public_path__ + "img/weSupport.6cb44b7b.png";